import React from 'react';
import { FormattedMessage } from 'react-intl';

import FixedImg from 'Components/Utility/FixedImg';

export default function UtalkFeatures() {
  return (
    <div className="utalk-features">
      <h3 className="section-heading">
        <FormattedMessage id="utalk.features.title" defaultMessage="How does uTalk work?" />
      </h3>
      <p>
        <FormattedMessage
          id="utalk.features.introduction"
          defaultMessage="Scientists, researchers and linguists all pooled their expertise to help make uTalk. Here’s why it works:"
        />
      </p>

      <div className="features-point point-one">
        <div className="features-point-image">
          <FixedImg
            src="feature-one-v2.png"
            folder="product/utalk"
            alt="uTalk feature"
            width="90"
          />
        </div>
        <div className="features-point-text">
          <FormattedMessage
            id="utalk.features.feature-one"
            defaultMessage="Linking a word to an image creates a stronger memory than using words alone, so each word or phrase you hear on uTalk is represented by a picture."
          />
        </div>
      </div>

      <div className="features-point point-two">
        <div className="features-point-image">
          <FixedImg
            src="feature-two.png"
            folder="product/utalk"
            alt="uTalk feature"
            width="90"
          />
        </div>
        <div className="features-point-text">
          <FormattedMessage
            id="utalk.features.feature-two"
            defaultMessage="All voices you hear in each language are authentic native speakers, both male and female for each word and phrase. Voice recognition technology is good but it’s still not as good as the human ear. That’s why users are asked to judge for themselves how their pronunciation compares with a native speaker’s as part of two uTalk games."
          />
        </div>
      </div>

      <div className="features-point point-three">
        <div className="features-point-image">
          <FixedImg
            src="feature-three.png"
            folder="product/utalk"
            alt="uTalk feature"
            width="90"
          />
        </div>
        <div className="features-point-text">
          <FormattedMessage
            id="utalk.features.feature-three"
            defaultMessage="Repeating new information boosts your memory so words you want to learn pop up in different games and words you struggle with are identified by intelligent software and crop up more often."
          />
        </div>
      </div>

      <div className="features-point point-four">
        <div className="features-point-image">
          <FixedImg
            src="feature-four.png"
            folder="product/utalk"
            alt="uTalk feature"
            width="90"
          />
        </div>
        <div className="features-point-text">
          <FormattedMessage
            id="utalk.features.feature-four"
            defaultMessage="uTalk’s Practice section introduces new words into your short-term memory while its other five games, which get progressively more challenging, are aimed at getting them into your long-term memory. The games are designed to be short but hard enough that you are unlikely to get full marks first time – giving you time to stop, refresh and come back to a topic later on. That’s because spaced repetition does more for your memory than cramming."
          />
        </div>
      </div>

      <div className="features-point point-five">
        <div className="features-point-image">
          <FixedImg
            src="feature-five.png"
            folder="product/utalk"
            alt="uTalk feature"
            width="90"
          />
        </div>
        <div className="features-point-text">
          <FormattedMessage
            id="utalk.features.feature-five"
            defaultMessage="uTalk makes learning fun and that releases a feel-good chemical into our bloodstream which boosts motivation. So keep up the good work, play the games, score points and enjoy!"
          />
        </div>
      </div>
    </div>
  );
}
